// Origem do cadastro (UTM + site de referência).
//
// Na primeira visita guardamos de onde a pessoa veio no localStorage por 30
// dias (mesmo padrão de referral.js/partner.js) e, no signup, gravamos o
// resultado em users/{uid}.attribution. Diferente dos outros códigos, NÃO
// limpamos a URL: o GA4 e o Meta Pixel precisam enxergar os parâmetros utm_*.
//
// Regra: vale o primeiro contato, exceto que uma visita com utm_source
// substitui um registro que não tinha utm (campanha paga ganha de orgânico).
// A origem final (`source`) é resolvida em um só lugar, aqui:
//   utm_source > parceiro (?parc=) > site de referência > 'direto'.

const KEY = 'mdc:attribution';
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 dias

const clean = (value, max = 60, allowSlash = false) => String(value || '')
  .trim()
  .toLowerCase()
  .replace(allowSlash ? /[^a-z0-9._\-/ ]/g : /[^a-z0-9._\- ]/g, '')
  .slice(0, max);

function externalReferrerHost() {
  try {
    if (!document.referrer) return '';
    const host = new URL(document.referrer).hostname.replace(/^www\./, '').toLowerCase();
    if (!host || host === window.location.hostname.replace(/^www\./, '')) return '';
    return clean(host, 80);
  } catch { return ''; }
}

function readStored() {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || Date.now() - data.savedAt > TTL_MS) {
      window.localStorage.removeItem(KEY);
      return null;
    }
    return data;
  } catch { return null; }
}

// Chamado uma vez no main.jsx, a cada carga da página.
export function captureAttributionFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const utmSource = clean(params.get('utm_source'));
    const utmMedium = clean(params.get('utm_medium'));
    const utmCampaign = clean(params.get('utm_campaign'), 80);
    const referrerHost = externalReferrerHost();
    if (!utmSource && !referrerHost) return;

    const stored = readStored();
    if (stored && (stored.utmSource || !utmSource)) return;

    window.localStorage.setItem(KEY, JSON.stringify({
      utmSource, utmMedium, utmCampaign, referrerHost,
      landingPath: clean(window.location.pathname, 100, true),
      savedAt: Date.now(),
    }));
  } catch { /* SSR/localStorage bloqueado: atribuição é só métrica */ }
}

// Devolve o objeto gravado no users doc. Sempre tem `source`, assim quem
// cadastrou sem utm/referência aparece como 'direto' e só os usuários
// anteriores a esta função ficam sem o campo.
export function getAttribution({ partnerCode = '' } = {}) {
  const stored = readStored() || {};
  const source = stored.utmSource || (partnerCode ? 'parceiro' : '') || stored.referrerHost || 'direto';
  const out = { source };
  if (stored.utmMedium) out.medium = stored.utmMedium;
  if (stored.utmCampaign) out.campaign = stored.utmCampaign;
  if (stored.referrerHost) out.referrerHost = stored.referrerHost;
  if (stored.landingPath) out.landingPath = stored.landingPath;
  return out;
}

export function clearAttribution() {
  try { window.localStorage.removeItem(KEY); } catch { /* noop */ }
}
